import tags from "../../../components/tags";
import { icons } from "../../../components/html";
import { statusCodes } from "../../../components/responses";

const responses = {
  "200": {
    content: {
      "application/json": {
        schema: {
          type: "array",
          items: {
            type: "object",
            properties: {
              id: {
                type: "string",
                description: "unikátní identifikátor míry",
                example: "bodyHeight"
              },
              label: {
                type: "string",
                description: "unikátní identifikátor míry",
                example: "Výška postavy"
              },
              advanced: {
                type: "boolean",
                description:
                  "určuje jestli patří mezi základní nebo pokročilé míry",
                example: "false"
              },
              limits: {
                $ref: "#/components/schemas/measureLimits"
              },
              hints: {
                $ref: "#/components/schemas/measurementInstruction"
              },
              images: {
                $ref: "#/components/schemas/measureImages"
              },
              gender: {
                $ref: "#/components/schemas/gender"
              },
              value: {
                oneOf: [
                  { $ref: "#/components/schemas/gender" },
                  { type: "null" }
                ],
                example: {
                  id: "1",
                  label: "Žena"
                }
              }
            }
          }
        }
      }
    }
  },
  ...statusCodes
};
export default {
  "/user/measures": {
    get: {
      tags: [tags.sizeIdAccount],
      summary: `User size profile`,
      description: `${icons.u}
      Returns size profile (measures) of logged user.`,
      parameters: [{ $ref: "#/components/parameters/acceptsLanguages" }],
      responses,
      security: [{ user: [] }]
    },
    put: {
      tags: [tags.sizeIdAccount],
      summary: "Change of user size profile.",
      description: `${icons.u}
      Change size profile (measures) of logged user.`,
      requestBody: {
        required: true,
        description: "An array of objects to be modified by the method ",
        content: {
          "application/json": {
            schema: {
              type: "array",
              items: {
                type: "object",
                example: {
                  id: "bodyHeight",
                  value: 158
                }
              }
            }
          }
        }
      },
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/contentType" }
      ],

      responses,
      security: [{ user: [] }]
    }
  }
};
